export const USERS = {
    login: "login",
    loginGoogle: "login/google",
    users: "add-user",
    orderByUser: "users/{userId}/orders",
    usersInactive: "users/inactive",
    usersActivate: "users/{userId}/activate",
    requestPasswordReset: "users/request-password-reset",
    resetPassword: "users/reset-password",
    sendOtp: "users/send-otp",
    verifyEmail: "users/verify-email",
    updateProfile: "users/update-profile",
}

export const RESTAURANTS = {
    addRestaurants: "restaurants/add-restaurants",
    getRestaurants: "restaurants/get-restaurants",
    getRestaurantById: "restaurants/get-restaurant-by-id",
    uploadProductImage: "restaurants/uploadProductImage",
    getMyRestaurants: "restaurants/get-my-restaurants",
    editMyRestaurant: "restaurants/edit-my-restaurant",
    paymentStatus: "restaurants/{restauranteId}/orders/payment-status"
}

export const MERCADO_PAGO = {
    createPreference: "checkout/preferences"
}

export const ORDERS = {
    createOrder: "restaurants/{restauranteId}/create-order",
    getOrdersByRestaurant: "restaurants/{restauranteId}/orders",
    changeStatus: "restaurants/{restauranteId}/orders/status",
    activeOrders: "restaurants/inactive",
    changeActiveRestaurant: "restaurants/{restauranteId}/activate",
};

export const REPARTIDORES = {
    getOrdersRepartidores: "courier/orders",
    assignOrder: "courier/orders/assign",
    viewOrders: "courier/my-orders"
}

// Constants/Endpoints.js
export const PAYMENTS = {
    createPreference: "payments/create-preference", // Lambda route
};

export const WEBHOOK = {
    webhookMP: "webhook/mp"
}

export const CATEGORIAS = {
    categorias: "categoria/{categoriaPrincipal}"
}

export const REPORTS = {
    weeklySales: "restaurants/{restauranteId}/reports/weekly-sales",
    // Todos los negocios a la vez (solo admin) — para saber a quién pagarle esta semana
    adminWeeklySales: "restaurants/reports/weekly-sales",
    // Lo que tiene que cobrar el repartidor esta semana ($ por entrega + propinas)
    courierWeeklyEarnings: "courier/reports/weekly-earnings",
    // Todos los repartidores a la vez (solo admin) — para saber a quién pagarle esta semana
    adminCourierWeeklyEarnings: "courier/reports/weekly-earnings/all",
    // Marcar/desmarcar si ya se pagó algo esta semana (solo admin)
    setPaymentStatus: "admin/reports/payment-status",
}
